import _ from 'underscore';

export const URL_COLON_SLASH_SLASH = '://';
export const DEFAULT_URL_PREFIX = 'https';

export function getUrlPrefixAndDestination(finalUrl, defaultUrlPrefix = DEFAULT_URL_PREFIX) {
  const index = _.isString(finalUrl) ? finalUrl.indexOf(URL_COLON_SLASH_SLASH) : -1;
  if (index >= 0) {
    const prefix = finalUrl.substring(0, index).toLowerCase();
    const destination = finalUrl.substring(index + URL_COLON_SLASH_SLASH.length).trim();

    return [prefix, destination];
  }

  return [defaultUrlPrefix, ''];
}

export const getUpdatedFullUrlOnPrefixUpdate =
  (urlWithoutPrefix, newPrefix) => {
    let slash = '';
    if (!newPrefix.includes(URL_COLON_SLASH_SLASH)) {
      slash = URL_COLON_SLASH_SLASH;
    }

    return `${newPrefix}${slash}${urlWithoutPrefix}`;
  };

export const getUpdatedFullUrlOnTextUpdate = (urlPrefix, newValue) => {
  if (newValue.includes(URL_COLON_SLASH_SLASH)) {
    // detect if the user is entering a URL and update the URL prefix
    const [prefix, destination] = getUrlPrefixAndDestination(newValue);

    if (prefix === 'http' || prefix === 'https') {
      return `${prefix}${URL_COLON_SLASH_SLASH}${destination}`;
    }
  }

  return `${urlPrefix}${URL_COLON_SLASH_SLASH}${newValue.trim()}`;
};

export const isEmptyUrl = (finalUrls) => {
  // FinalUrlWithCustomValidation contol always specifies prefix. If destination is empty
  // then treat this as empty final URL. This is needed for when final URL is optional and
  // we want to avoid specifying prefixed empty URL.
  const [, dest] = getUrlPrefixAndDestination(_.first(finalUrls));
  return _.isEmpty(dest);
};
